<template>
    <div class="p-order">
        <Breadcrumb></Breadcrumb>
        <div class="form-body searchBox">
            <el-form ref="form" :model="form" label-width="80px">
                <el-row>
                   <el-col :span="8">
                       <el-form-item label="订单编号" prop="orderNum">
                           <el-input size="small" v-model.trim="form.orderNum" style="width: 250px"></el-input>
                       </el-form-item>
                   </el-col>
                   <el-col :span="8">
                       <el-form-item label="产品名称" prop="prodTitle">
                           <el-input size="small" v-model="form.prodTitle" style="width: 250px"></el-input>
                       </el-form-item>
                   </el-col>
                   <el-col :span="8">
                       <el-form-item prop="orderStatus" label="订单状态" >
                           <el-select clearable  size="small" v-model.trim="form.orderStatus" style="width: 250px">
                               <el-option label="全部" value=""></el-option>
                               <el-option v-for="item in statusList"
                                          :key="item.dictCode"
                                          :label="item.dictLabel"
                                          :value="item.dictValue">
                               </el-option>
                           </el-select>
                       </el-form-item>
                   </el-col>
                </el-row>
                <el-row style="margin-top: 7px">
                    <el-col :span="8">
                        <el-form-item label="商家账号" prop="pOpeNo">
                            <el-input size="small" v-model="form.pOpeNo" style="width: 250px"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="下单时间" prop="createTime">
                            <el-date-picker
                                    size="small"
                                    v-model="form.createTime"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    format="yyyy-MM-dd "
                                    value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                                    style="width: 250px">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item>
                            <el-button size="small" type="info" plain @click="resetForm">重置</el-button>
                            <el-button size="small" type="primary" @click="loadData">搜索</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>

        <div class="tab-body">
            <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="定制订单" name="01">
                    <custom-order :params="form" :customStateList="customOrderStatus" ref="customTab"></custom-order>
                </el-tab-pane>
                <el-tab-pane label="优选订单" name="02">
                    <normal-order :params="form" :normalStateList="normalOrderStatus" ref="normalTab"></normal-order>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    // 本平台订单
    import Breadcrumb from '@/components/common/Breadcrumb'
    import CustomOrder from './platOrderType/customOrder'
    import NormalOrder from './platOrderType/normalOrder'
    export default {
        name: "platOrder",
        components:{Breadcrumb,CustomOrder,NormalOrder},
        data(){
            return{
                total:0,
                form:{
                    orderStatus:'',//订单状态
                    orderNum:undefined,//订单编号
                    prodTitle:undefined,//产品名称
                    pOpeNo:undefined,//商家账号
                    createTime:undefined,//订单创建时间
                },
                statusList:[],
                normalOrderStatus:[],//优选商品订单状态集合
                customOrderStatus:[],//定制订单状态集合
                activeName:'01'
            }
        },
        created() {
            this.loadOrderStatus();
        },
        methods:{
            loadData(){
                if(this.activeName == '01'){
                    this.$refs.customTab.loadData();
                }else{
                    this.$refs.normalTab.loadData();
                }
            },
            handleClick(val){
                if(val.name == '01'){
                    this.statusList = this.customOrderStatus;
                }else{
                    this.statusList = this.normalOrderStatus;
                }
            },
            resetForm(){
                this.$refs['form'].resetFields();
                this.form.createTime = undefined;
            },
            //获取定制订单状态数据
            loadOrderStatus(){
                this.getDicts("dz_order_status").then(res => {
                    this.customOrderStatus = res.data;
                    this.statusList = res.data;
                });
                this.getDicts("order_status").then(res =>{
                    this.normalOrderStatus = res.data;
                    this.statusList = res.data;
                }).catch(err =>{});
            }
        }
    }
</script>

<style scoped>
    .p-order >>>.el-tabs--border-card>.el-tabs__header {
        background: white !important;
    }

</style>
